import React from 'react';
import { Link } from 'react-router-dom';
import MetaTags from '../components/SEO/MetaTags';
import { HomeIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-naqd-dark to-naqd-dark-gray px-4">
            <MetaTags
                title="404 - Page Not Found | NAQD Consulting"
                description="The page you're looking for doesn't exist. Return to NAQD Consulting homepage for chartered accountancy services in Malappuram, Kerala."
            />

            <div className="max-w-2xl w-full text-center">
                {/* 404 Illustration */}
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-naqd-green mb-4">404</h1>
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-naqd-dark-text">
                        Page Not Found
                    </h2>
                    <p className="text-xl text-gray-300 mb-8">
                        Oops! The page you're looking for doesn't exist or has been moved.
                    </p>
                </div>

                {/* Quick Links */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                    <Link
                        to="/"
                        className="card hover:border-naqd-green transition-all group"
                    >
                        <HomeIcon className="w-8 h-8 text-naqd-green mx-auto mb-2" />
                        <h3 className="font-semibold mb-1">Homepage</h3>
                        <p className="text-sm text-gray-400">Return to main page</p>
                    </Link>

                    <Link
                        to="/services"
                        className="card hover:border-naqd-green transition-all group"
                    >
                        <svg className="w-8 h-8 text-naqd-green mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <h3 className="font-semibold mb-1">Our Services</h3>
                        <p className="text-sm text-gray-400">Explore what we offer</p>
                    </Link>

                    <Link
                        to="/contact"
                        className="card hover:border-naqd-green transition-all group"
                    >
                        <EnvelopeIcon className="w-8 h-8 text-naqd-green mx-auto mb-2" />
                        <h3 className="font-semibold mb-1">Contact Us</h3>
                        <p className="text-sm text-gray-400">Get in touch</p>
                    </Link>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to="/" className="btn-primary">
                        Go to Homepage
                    </Link>
                    <a href="tel:+919074286763" className="btn-secondary flex items-center justify-center">
                        <PhoneIcon className="w-5 h-5 mr-2" />
                        Call: +91 90742 86763
                    </a>
                </div>

                {/* Search Suggestion */}
                <div className="mt-12 text-gray-400 text-sm">
                    <p>Looking for something specific?</p>
                    <div className="mt-4 flex flex-wrap gap-2 justify-center">
                        <Link to="/services" className="text-naqd-green hover:underline">Tax Planning</Link>
                        <span>•</span>
                        <Link to="/services" className="text-naqd-green hover:underline">GST Compliance</Link>
                        <span>•</span>
                        <Link to="/services" className="text-naqd-green hover:underline">Business Registration</Link>
                        <span>•</span>
                        <Link to="/blog" className="text-naqd-green hover:underline">Blog</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
